import { OfficeAnnualPlan, SubscriptionType } from "../../models/annual-plan.model";

export const annualPlanTypes = [
  {
    annualPlanTypeId: "bce14b12-ea26-4b07-9dd7-1b15da101396",
    name: "Single",
    planName: "Individual Plan",
    subscriptionType: SubscriptionType.Monthly,
  },
  {
    annualPlanTypeId: "bce14b12-ea26-4b07-9dd7-1b15da101397",
    name: "Single",
    planName: "Individual Plan",
    subscriptionType: SubscriptionType.Yearly,
  },
  {
    annualPlanTypeId: "a221b93a-fff4-4786-85f8-b042c454645b",
    name: "Couple",
    planName: "Couples Plan",
    subscriptionType: SubscriptionType.Monthly,
  },
  {
    annualPlanTypeId: "a221b93a-fff4-4786-85f8-b042c454645c",
    name: "Couple",
    planName: "Couples Plan",
    subscriptionType: SubscriptionType.Yearly,
  },
  {
    annualPlanTypeId: "02bd43d4-a34f-4834-bc08-07070bf8e934",
    name: "Family",
    planName: "Family Plan",
    subscriptionType: SubscriptionType.Monthly,
  },
  {
    annualPlanTypeId: "02bd43d4-a34f-4834-bc08-07070bf8e935",
    name: "Family",
    planName: "Family Plan",
    subscriptionType: SubscriptionType.Yearly,
  },
  {
    annualPlanTypeId: "ef567679-5292-4721-90ad-a2343290632a",
    name: "Senior",
    planName: "Senior Individual Plan",
    subscriptionType: SubscriptionType.Monthly,
  },
  {
    annualPlanTypeId: "ef567679-5292-4721-90ad-a2343290632b",
    name: "Senior",
    planName: "Senior Individual Plan ",
    subscriptionType: SubscriptionType.Yearly,
  },
  {
    annualPlanTypeId: "06c5e35a-7fd3-11ec-a8a3-0242ac120002",
    name: "SeniorCouple",
    planName: "Senior Couples Plan",
    subscriptionType: SubscriptionType.Monthly,
  },
  {
    annualPlanTypeId: "06c5e35a-7fd3-11ec-a8a3-0242ac120003",
    name: "SeniorCouple",
    planName: "Senior Couples Plan",
    subscriptionType: SubscriptionType.Yearly,
  },
];

export const annualPlansSampleData: OfficeAnnualPlan[] = [
  {
    officeAnnualPlanId: 'asd',
    numSubscribers: 0,
    officeId: "3",
    annualPlanType: {
      annualPlanTypeId: "5",
      name: "Single",
      subscriptionType: SubscriptionType.Monthly,
    }, // See details on annual plan type model above
    subscription: {
      subscriptionId: "5",
      subscriptionType: SubscriptionType.Monthly,
      stripeProductId: "test",
      price: 0,
    },
  },
  {
    officeAnnualPlanId: 'asd',
    numSubscribers: 0,
    officeId: "3",
    annualPlanType: {
      annualPlanTypeId: "6",
      name: "Single",
      subscriptionType: SubscriptionType.Yearly,
    }, // See details on annual plan type model above
    subscription: {
      subscriptionId: "6",
      subscriptionType: SubscriptionType.Yearly,
      stripeProductId: "test",
      price: 0,
    },
  },
  {
    officeAnnualPlanId: 'asd',
    numSubscribers: 0,
    officeId: "1",
    annualPlanType: {
      annualPlanTypeId: "1",
      name: "Couple",
      subscriptionType: SubscriptionType.Monthly,
    }, // See details on annual plan type model above
    subscription: {
      subscriptionId: "1",
      subscriptionType: SubscriptionType.Monthly,
      stripeProductId: "test",
      price: 0,
    },
  },
  {
    officeAnnualPlanId: 'asd',
    numSubscribers: 0,
    officeId: "1",
    annualPlanType: {
      annualPlanTypeId: "1",
      name: "Couple",
      subscriptionType: SubscriptionType.Yearly,
    }, // See details on annual plan type model above
    subscription: {
      subscriptionId: "1",
      subscriptionType: SubscriptionType.Yearly,
      stripeProductId: "test",
      price: 0,
    },
  },
  {
    officeAnnualPlanId: 'asd',
    numSubscribers: 0,
    officeId: "4",
    annualPlanType: {
      annualPlanTypeId: "7",
      name: "Family",
      subscriptionType: SubscriptionType.Monthly,
    }, // See details on annual plan type model above
    subscription: {
      subscriptionId: "7",
      subscriptionType: SubscriptionType.Monthly,
      stripeProductId: "test",
      price: 0,
    },
  },
  {
    officeAnnualPlanId: 'asd',
    numSubscribers: 0,
    officeId: "4",
    annualPlanType: {
      annualPlanTypeId: "8",
      name: "Family",
      subscriptionType: SubscriptionType.Yearly,
    }, // See details on annual plan type model above
    subscription: {
      subscriptionId: "8",
      subscriptionType: SubscriptionType.Yearly,
      stripeProductId: "test",
      price: 0,
    },
  },
  {
    officeAnnualPlanId: 'asd',
    numSubscribers: 0,
    officeId: "2",
    annualPlanType: {
      annualPlanTypeId: "3",
      name: "Senior",
      subscriptionType: SubscriptionType.Monthly,
    }, // See details on annual plan type model above
    subscription: {
      subscriptionId: "3",
      subscriptionType: SubscriptionType.Monthly,
      stripeProductId: "test",
      price: 0,
    },
  },
  {
    officeAnnualPlanId: 'asd',
    numSubscribers: 0,
    officeId: "2",
    annualPlanType: {
      annualPlanTypeId: "4",
      name: "Senior",
      subscriptionType: SubscriptionType.Yearly,
    }, // See details on annual plan type model above
    subscription: {
      subscriptionId: "4",
      subscriptionType: SubscriptionType.Yearly,
      stripeProductId: "test",
      price: 0,
    },
  },
  {
    officeAnnualPlanId: 'asd',
    numSubscribers: 0,
    officeId: "5",
    annualPlanType: {
      annualPlanTypeId: "9",
      name: "Senior Couple",
      subscriptionType: SubscriptionType.Monthly,
    }, // See details on annual plan type model above
    subscription: {
      subscriptionId: "9",
      subscriptionType: SubscriptionType.Monthly,
      stripeProductId: "test",
      price: 0,
    },
  },
  {
    officeAnnualPlanId: 'asd',
    numSubscribers: 0,
    officeId: "5",
    annualPlanType: {
      annualPlanTypeId: "10",
      name: "Senior Couple",
      subscriptionType: SubscriptionType.Yearly,
    }, // See details on annual plan type model above
    subscription: {
      subscriptionId: "10",
      subscriptionType: SubscriptionType.Yearly,
      stripeProductId: "test",
      price: 0,
    },
  },
];

export const customOrder = ["Individual Plan", "Couples Plan", "Family Plan", "Senior Individual Plan", "Senior Couples Plan"];